/**
 * The dev-only warning latch the appearance API (`surface` / `rim`) shares
 * across both search-field twins, so a value one of them rejects is reported
 * once rather than once per twin. Its own module rather than
 * `search-field.shared` so reaching it does not drag that file's stylesheet
 * import into AiSearchField.
 */

/* ⚠ One warning per bad value, not one per render: every check runs during
   render, StrictMode runs the body twice on mount, and a stateful parent
   re-emits on each keystroke above the field. The key is the CALLER's to
   choose — it decides whether two call sites share a warning or get one each. */
const warnedAppearanceValues = new Set<string>();

export function warnAboutAppearanceOnce(key: string, message: string) {
  if (warnedAppearanceValues.has(key)) {
    return;
  }

  warnedAppearanceValues.add(key);
  console.warn(message);
}

/** Test-only, and the `__` prefix is the enforcement the JSDoc alone is not:
 * the set above is module state, so without this a spec that asserts a warning
 * depends on running before every other spec that triggers the same key. */
export function __resetAppearanceWarningsForTests() {
  warnedAppearanceValues.clear();
}
